import swal from "sweetalert";
import { api } from "../../Api/api";
import { getToken } from "../login";
import {
  CREATE_ROLE_FAIL,
  CREATE_ROLE_REQUEST,
  CREATE_ROLE_SUCCESS,
  FETCH_ROLE_FAIL,
  FETCH_ROLE_REQUEST,
  FETCH_ROLE_SUCCESS,
} from "../../ActionType/RoleType/RoleType";

export const getRoleAction = (page, perPage, name) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    params: {
      page,
      perPage,
      name,
    },
  };
  dispatch({
    type: FETCH_ROLE_REQUEST,
    payload: [],
  });
  try {
    const response = await api.get("role", config);
    const { status, data } = response;

    if (status == 200) {
      dispatch({
        type: FETCH_ROLE_SUCCESS,
        payload: { data: data.data.data, total: data.total },
      });
    }
  } catch (error) {
    console.log(error);
    dispatch({
      type: FETCH_ROLE_FAIL,
      payload: [],
    });
  }
};

export const createRoleAction = (name) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };
  dispatch({
    type: CREATE_ROLE_REQUEST,
    payload: [],
  });
  try {
    const response = await api.post("role/create", { name }, config);
    const { status, data } = response;
    if (status == 201) {
      swal({
        title: "Good job!",
        text: "Role was saved Successfully !",
        icon: "success",
        button: "OK",
        timer: 2000,
      });

      dispatch({
        type: CREATE_ROLE_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    dispatch({
      type: CREATE_ROLE_FAIL,
      payload: [],
    });
  }
};

export const updateRoleAction = (id, name) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };
  dispatch({
    type: CREATE_ROLE_REQUEST,
    payload: [],
  });
  try {
    const response = await api.patch("role/update/" + id, { name }, config);
    const { status, data } = response;
    if (status == 200) {
      swal({
        title: "Good job!",
        text: "Role was update Successfully !",
        icon: "success",
        button: "OK",
        timer: 2000,
      });

      dispatch({
        type: CREATE_ROLE_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    dispatch({
      type: CREATE_ROLE_FAIL,
      payload: [],
    });
  }
};
